export const ESUZ_ISSUES_TYPES_KEY = {
  ahp_tech_mode     : `На изменение тех. режима по РС и РО`,
  ahp_tech_violation: `На тех. нарушения по СО`,
  ahp_exploitation  : `Эксплуатационные заявки`,
  dataIsEmpty       : `Нет данных`,
}

export const ISSUE_LINK_SYSTEM_TYPE = {
  ahp : `AHP`,
  toir: `TOIR`,
}
